import { render } from "./Team.vue?vue&type=template&id=0b10c848&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0b10c848"

export default script